import { useEffect } from "react";

const CALENDLY_URL = "https://calendly.com/binaifer-talented";

export default function Booking() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);

    const link = document.createElement("link");
    link.href = "https://assets.calendly.com/assets/external/widget.css";
    link.rel = "stylesheet";
    document.head.appendChild(link);

    return () => {
      try {
        document.body.removeChild(script);
        document.head.removeChild(link);
      } catch (e) {}
    };
  }, []);

  return (
    <section
      id="booking"
      data-testid="booking-section"
      className="relative py-28 md:py-36 bg-white border-t border-black/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28 reveal">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#6B6B6B] mb-6 font-medium">
              05. Book a Session
            </div>
            <h2 className="font-display text-[#0A0A0A] text-[32px] sm:text-[40px] lg:text-[52px] font-light leading-[1.08] tracking-[-0.025em]">
              A first conversation
            </h2>
            <p className="mt-8 text-[16px] md:text-[18px] text-[#3A3A3A] leading-[1.7] font-normal max-w-md">
              Pick a time that works. We'll talk about where you are, where
              you'd like to be, and whether coaching is the right next step.
              Held over Google Meet or Zoom.
            </p>

            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="booking-fallback-link"
              className="mt-10 inline-flex items-center gap-2 text-[14px] font-medium text-[#0A0A0A] hover:opacity-60 transition-opacity"
            >
              Open Calendly in a new tab
              <span aria-hidden>↗</span>
            </a>
          </div>

          <div className="lg:col-span-7 reveal">
            <div
              data-testid="calendly-embed"
              className="calendly-inline-widget border border-black/10 bg-white rounded-2xl overflow-hidden"
              data-url={`${CALENDLY_URL}?hide_event_type_details=0&hide_gdpr_banner=1&primary_color=0A0A0A`}
              style={{ minWidth: "320px", height: "780px" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
